import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { ContextMenuConfiguration, IContextMenuOption, OpenContextMenuEventName } from '@/app-modules/tombola-context-menu';

@Component({
  name: 'ContextMenuComponent'
})
export default class ContextMenuComponent extends TombolaBaseComponent {
  private readonly browserScrollBarWidthInPixels: number = 25;
  private clickEventHandler: () => void;
  private contextMenuEventHandler: () => void;
  private menuConfig: ContextMenuConfiguration = null;
  private isVisible: boolean = false;
  private contextMenuXPosition: string = '0px';
  private contextMenuYPosition: string = '0px';

  private beforeMount() {
    this.removeExistingCloseMenuEvents();
    this.setupEventBusEmitter();
  }

  private beforeDestroy() {
    this.removeExistingCloseMenuEvents();
  }

  private removeExistingCloseMenuEvents() {
    if (this.clickEventHandler) {
      window.removeEventListener('click', this.clickEventHandler);
      this.clickEventHandler = null;
    }

    if (this.contextMenuEventHandler) {
      window.removeEventListener('contextmenu', this.contextMenuEventHandler);
      this.contextMenuEventHandler = null;
    }
  }

  private setupCloseMenuEvents() {
    this.clickEventHandler = this.handleContextMenuEvent.bind(this);
    this.contextMenuEventHandler = this.handleContextMenuEvent.bind(this);
    window.addEventListener('click', this.clickEventHandler);
    window.addEventListener('contextmenu', this.contextMenuEventHandler);
  }

  private handleContextMenuEvent(): void {
    this.closeMenu();
    this.removeExistingCloseMenuEvents();
  }

  public setMenuPosition(mouseEvent: MouseEvent) {
    let top: number = mouseEvent.y;
    let left: number = mouseEvent.x;

    const largestHeight: number = window.innerHeight - this.$el.clientHeight - this.browserScrollBarWidthInPixels;
    const largestWidth: number = window.innerWidth - this.$el.clientWidth;

    top = (top > largestHeight) ? largestHeight : top;
    left = (left > largestWidth) ? largestWidth : left;

    this.contextMenuYPosition = top + 'px';
    this.contextMenuXPosition = left + 'px';
  }

  private showMenu(menuConfig: ContextMenuConfiguration) {
    this.menuConfig = menuConfig;
    this.isVisible = true;
  }

  private closeMenu() {
    this.isVisible = false;
  }

  private preventBrowserContextMenu(mouseEvent: MouseEvent) {
    mouseEvent.preventDefault();
    mouseEvent.stopPropagation();
  }

  private setupEventBusEmitter() {
    this.$eventbus.$on(OpenContextMenuEventName, (mouseEvent: MouseEvent, menuConfig: ContextMenuConfiguration) =>  {
      this.removeExistingCloseMenuEvents();
      this.closeMenu();
      Vue.nextTick(() => {
        this.showMenu(menuConfig);
        Vue.nextTick(() => {
          this.setMenuPosition(mouseEvent);
        });
      });
      this.setupCloseMenuEvents();
      this.preventBrowserContextMenu(mouseEvent);
    });
  }

  private menuOptionSelected(menuOption: IContextMenuOption) {
    if (menuOption.isDisabled){
      return;
    }
    if (menuOption.menuOptionSelectedCallback) {
      menuOption.menuOptionSelectedCallback();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/tombola-context-menu/tombola-context-menu.component.ts